import React from "react";
import { FaCircle } from "react-icons/fa";

export default function ListaUsuarios({
  usuarios,
  usuarioAtivo,
  setUsuarioAtivo,
  carregando,
}) {
  return (
    <div className="w-[22%] min-w-[220px] bg-gray-50 border-r border-gray-300 flex flex-col overflow-hidden">
      {/* Cabeçalho escuro proporcional ao da conversa */}
      <div className="bg-[#4d4d4d] text-white p-3 flex items-center justify-center shadow-sm">
        <h2
          className="text-base font-semibold uppercase tracking-wide"
          style={{
            fontFamily: "'Comfortaa', cursive",
          }}
        >
          Usuários
        </h2>
      </div>

      {carregando ? (
        <p className="text-gray-500 text-center mt-4">Carregando...</p>
      ) : usuarios.length === 0 ? (
        <p className="text-gray-500 text-center mt-4">
          Nenhum usuário encontrado.
        </p>
      ) : (
        <div className="flex-1 overflow-y-auto">
          {usuarios.map((u) => (
            <div
              key={u.id || u.nome}
              onClick={() => setUsuarioAtivo(u)} // ✅ Aqui o ajuste
              className={`flex items-center gap-3 p-3 cursor-pointer border-b border-gray-200 transition-all duration-150 ${
                usuarioAtivo?.id === u.id
                  ? "bg-[#f97316] text-white" // 🟠 Fundo laranja no ativo
                  : "hover:bg-gray-100 text-gray-800"
              }`}
            >
              <FaCircle
                size={10}
                className={u.online ? "text-green-400" : "text-gray-400"}
              />
              <span
                className="text-sm font-medium truncate"
                style={{ fontFamily: "'Comfortaa', cursive" }}
              >
                {u.nome}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
